import { render, staticRenderFns } from "./v-custom-reassign-utms.vue?vue&type=template&id=f587d7dc&"
import script from "./v-custom-reassign-utms.vue?vue&type=script&lang=js&"
export * from "./v-custom-reassign-utms.vue?vue&type=script&lang=js&"
import style0 from "./v-custom-reassign-utms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAutocomplete,VCol,VRow,VSimpleTable})
